import { createContext } from "react";

export const AuthContext = createContext({state: {isAuthenticated: false, user: null, token: null}, dispatch: (action: any)=>{} });

